import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconSeats = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M16.1 22H4V18C4 16.9 4.9 16 6 16H12.2L14 8.6C14.2 7.7 15 7 16 7H20.2L18.1 20.3C18 21.3 17.1 22 16.1 22ZM6 20H16.1L17.8 9H16L13.8 18H6V20Z" }),
            React.createElement("path", { d: "M18 7C16.3 7 15 5.7 15 4C15 2.3 16.3 1 18 1C19.7 1 21 2.3 21 4C21 5.7 19.7 7 18 7ZM18 3C17.4 3 17 3.4 17 4C17 4.6 17.4 5 18 5C18.6 5 19 4.6 19 4C19 3.4 18.6 3 18 3Z" }))));
};
